import React, { useEffect, useState } from "react";

import { OnBoardingStepProps } from "../../../constants";
import Checkbox from "@mui/material/Checkbox";
import {
  BackButton,
  ButtonContainer,
  FormContainer,
  NextButton,
} from "../../../styles/PersonalInfoStep";
import {
  DayName,
  DayRow,
  DaysList,
  ErrorText,
  ModalContent,
  ModalLabel,
  ModalOverlay,
  ModalSaveButton,
  ModalTitle,
  RowContent,
  RowContentWrapper,
  StatusLabel,
  TimeBlock,
  TimeInput,
} from "../../../styles/businessHours";
import { POST } from "../../../services/HTTPServices";
import { setItem, setItemWithObject } from "../../../utils/cache/LocalStorage";
import {
  FullScreenContainer,
  StyledIframe,
} from "../../../styles/OTPVerificationStep";
import { useNavigate } from "react-router-dom";
import {
  alertMessage,
  alertMessageWithCancel,
} from "../../../services/alertService";
import { ALERT_TITLES, ALERT_MESSAGES } from "../../../constants";
import {
  LoadingSpinner,
  LoadingOverlay,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import Back from "../../../assets/svgs/LoginSignup/Step1/back.svg";

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const defaultHours = {
  open: true,
  start: "09:00",
  end: "18:00",
};

const initialState = DAYS.reduce((acc, day) => {
  acc[day] = { ...defaultHours };
  return acc;
}, {} as Record<string, { open: boolean; start: string; end: string }>);

const BusinessHours: React.FC<OnBoardingStepProps> = ({
  formData,
  onChange,
  onNext,
  onBack,
  onAssign,
  changedRole,
  isFromProfile,
}) => {
  const [hours, setHours] = useState(initialState);
  const [editingDay, setEditingDay] = useState<string | null>(null);
  const [editStart, setEditStart] = useState("");
  const [editEnd, setEditEnd] = useState("");
  const [error, setError] = useState("");
  const [kybURL, setKybURL] = React.useState("");
  const [loading, setLoading] = useState(false);
  const [serviceProviderId, setServiceProviderId] = React.useState("");

  const [authUser, setAuthUser] = React.useState({ name: "", id: -1 });
  const navigate = useNavigate();

  useEffect(() => {
    if (isFromProfile) {
      const openingHours = DAYS.map((day, index) => ({
        id: index,
        serviceProviderId: serviceProviderId && serviceProviderId !== "" ? serviceProviderId : 0,
        dayOfWeek: day,
        openingTime: hours[day].start,
        closingTime: hours[day].end,
        rowOrder: index,
        isClose: !hours[day].open,
        createdUserId: "",
      }));
      onChange("openingHours", openingHours);
    }
  }, [hours, isFromProfile, onChange, serviceProviderId]);



  useEffect(() => {
    if (formData.openingHours && formData.openingHours.length > 0) {
      setHours((prevHours) => {
        const updatedHours = { ...prevHours };
        formData.openingHours.forEach(
          (
            dayHours: { isClose: any; openingTime: any; closingTime: any },
            index: number
          ) => {
            if (index < DAYS.length) {
              const day = DAYS[index];
              updatedHours[day] = {
                ...updatedHours[day],
                open: !dayHours.isClose,
                start: dayHours.openingTime || defaultHours.start,
                end: dayHours.closingTime || defaultHours.end,
              };
            }
          }
        );
        return updatedHours;
      });
    }
  }, [formData.openingHours]);

  useEffect(() => {
    const serviceProviderId = localStorage.getItem("serviceProviderId") || "";
    if (serviceProviderId) {
      setServiceProviderId(serviceProviderId);
    }
    const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");
    if (tempUser) {
      tempUser.mobile = "+65" + tempUser.mobile;
      setAuthUser(tempUser);
    }
  }, []);

  const handleToggle = (day: string) => {
    setHours((prev) => ({
      ...prev,
      [day]: { ...prev[day], open: !prev[day].open },
    }));
  };

  const handleEdit = (day: string) => {
    setEditingDay(day);
    setEditStart(hours[day].start);
    setEditEnd(hours[day].end);
    setError("");
  };

  const handleSaveEdit = () => {
    if (editEnd <= editStart) {
      setError("Closing time must be after opening time.");
      return;
    }
    if (editingDay) {
      setHours((prev) => ({
        ...prev,
        [editingDay]: { ...prev[editingDay], start: editStart, end: editEnd },
      }));
    }

    setEditingDay(null);
    setError("");
  };

  const handleCancel = () => {
    const openingHours = DAYS.map((day, index) => ({
      id: index, // Add unique ID for key prop
      serviceProviderId:
        serviceProviderId && serviceProviderId !== "" ? serviceProviderId : 0,
      dayOfWeek: day,
      openingTime: hours[day].start,
      closingTime: hours[day].end,
      rowOrder: index,
      isClose: !hours[day].open,
      createdUserId: "",
    }));
    onChange("openingHours", openingHours);
    onBack("");
  };

  const handleSave = (e: any) => {
    e.preventDefault();
    const openingHours = DAYS.map((day, index) => ({
      id: index, // Add unique ID for key prop
      serviceProviderId:
        serviceProviderId && serviceProviderId !== "" ? serviceProviderId : 0,
      dayOfWeek: day,
      openingTime: hours[day].start,
      closingTime: hours[day].end,
      rowOrder: index,
      isClose: !hours[day].open,
      createdUserId: "",
    }));

    const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");
    if (tempUser) {
      tempUser.openingHours = openingHours;

      setItemWithObject("tempUser", tempUser);
    }

    onChange("openingHours", openingHours);
    signup(openingHours);
  };
  const signup = async (openingHours : any) => {
    setLoading(true);

    let url = "serviceprovider/CreateServiceProvider";
    let auth: any = authUser;
    const savedCoord = JSON.parse(localStorage.getItem("saved_coord") || "{}");
    const lat = savedCoord?.lat || "";
    const lng = savedCoord?.lng || "";

    let temp = {
      firstName: auth.firstName || "",
      lastName: auth.lastName || "",
      name: auth.name || "",
      email: auth.email || "",
      mobile: auth.mobile || "",
      idType: "NRIC",
      hawkerId: auth.hawkerId,
      nricFront: formData.nric,
      nricFrontPath: formData.nricPath,
      nricBack: [],
      nricBackPath: [],
      letterOfAuth: formData.letterOfAuth,
      letterOfAuthPath: formData.letterOfAuthPath,
      digitalCopies: [],
      digitalCopiesPath: [],

      sfaLicense: formData.sfaLicense,
      sfaLicensePath: formData.sfaLicensePath,
      halalLicense: formData.halalLicense,
      halalLicensePath: formData.halalLicensePath,
      storeCover: formData.storeCover,
      storeCoverPath: formData.storeCoverPath,
      catalogue: formData.catalogue,
      cataloguePath: formData.cataloguePath,
      storeCoverAR1: formData.storeCoverAR1,
      storeCoverAR1Path: formData.storeCoverAR1Path,
      shopName: auth.shopName,
      postcode: auth.postcode,
      city: auth.city,
      street: auth.street,
      building: auth.building,

      block: auth.block,
      floor: auth.floor,
      unit: auth.unit,
      latitude: lat ? lat + "" : "",
      longitude: lng ? lng + "" : "",

      entityName: auth.entityName || "",
      uen: auth.uen || "",
      signeeName: auth.signeeName || "",
      signeeNRIC: auth.signeeNRIC || "",

      companyName: auth.companyName || "",
      registrationNo: "",
      registrationDate: new Date().toISOString(),
      companyPhone: auth.companyPhone || "",

      companyEmail: auth.companyEmail || "",
      companyAddress: auth.companyAddress || "",
      businessType: auth.businessType || "",
      businessActivity: auth.businessActivity || "",
      businessActivity2: auth.businessActivity2 || "",
      website: auth.website || "",

      agreeTA: true,
      serviceProviderServices: [
        {
          serviceTypeId: 5,
        },
      ],
      openingHours: openingHours,
    };

    setTimeout(async () => {
      let res: any = await POST(url, temp, "provider", true);

      if (res && res.status === 200) {
        setLoading(false);

        setItem("serviceProviderId", res.data.id);
        setItemWithObject("authUser", res.data);

        setServiceProviderId(res.data.id);
        const confirmLeave = await alertMessageWithCancel(
          ALERT_TITLES.INFO,
          ALERT_MESSAGES.KYB_CONFIRMATION,
          "Proceed",
          "Not now"
        );

        setTimeout(() => {
          if (confirmLeave) {
            setItem("skipKyb", "false");
            gotoKYB(res.data.id);
          } else {
            setItem("skipKyb", "true");

            onNext();
          }
        }, 100);
      } else {
        setLoading(false);

        if (res.status && res.status === 401) navigate("/unauthorized-page");
        else {
          alertMessage(ALERT_TITLES.ERROR, res.message);
          onNext({ type: "error", errMsg: res.message });
        }
      }
    }, 300);
  };

  const gotoKYB = async (id: any) => {
    let temp = {
      businessType: "individual",
      email: formData.email,
      firstName: formData.firstName || "",
      kybVerificationRequestAddress: {
        city: formData.city,
        country: "Singapore",
        line1:
          formData.unit +
          " " +
          formData.streetName +
          ", Block " +
          formData.block +
          ", Singapore " +
          formData.postcode,
        line2: "",
        postalCode: formData.postcode,
      },
      kybVerificationRequestDateOfBirth: {
        day: 13,
        month: 7,
        year: 1995,
      },
      lastName: formData.lastName || "",
      phone: "+65" + formData.mobile,
      serviceProviderId: id + "",
      returnUrl: "http://localhost:3000/merchant-registration-kyb",
      refreshUrl: "http://localhost:3000/merchant-registration-kyb",
    };

    let url = "serviceprovider/RequestKYBVerification";

    let res: any = await POST(url, temp, "provider", true);

    if (res && res.status === 200) {
      setItem("accountId", res.data.accountId);

      setKybURL(res.data.onboardingUrl);
    } else {
      setLoading(false);
      if (res.status && res.status === 401) {
        navigate("/unauthorized-page");
      } else {
        alertMessage(ALERT_TITLES.ERROR, res.message);
      }
    }
  };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <FormContainer $isProfile={isFromProfile}>
        <DaysList>
          {DAYS.map((day) => (
            <DayRow key={day}>
              <DayName>{day}</DayName>
              <RowContentWrapper>
                <RowContent className="ml-negative-12">
                  <Checkbox
                    checked={hours[day].open}
                    onChange={() => handleToggle(day)}
                    className="green-checkbox"
                  />
                  <StatusLabel>Open</StatusLabel>
                </RowContent>

                <RowContent>
                  <TimeBlock
                    onClick={() => hours[day].open && handleEdit(day)}
                    disabled={!hours[day].open}
                  >
                    {hours[day].open
                      ? `${formatTime(hours[day].start)} - ${formatTime(
                          hours[day].end
                        )}`
                      : "Closed"}
                  </TimeBlock>
                </RowContent>
              </RowContentWrapper>
            </DayRow>
          ))}
        </DaysList>
        {!isFromProfile && (
          <ButtonContainer>
            <BackButton type="button" onClick={handleCancel}>
              <img src={Back} alt="Back" />
            </BackButton>
            <NextButton type="submit" onClick={handleSave}>
              Next
            </NextButton>
          </ButtonContainer>
        )}

        {editingDay && (
          <ModalOverlay>
            <ModalContent>
              <ModalTitle>{editingDay}</ModalTitle>
              <ModalLabel>Opening Time</ModalLabel>
              <TimeInput
                type="time"
                value={editStart}
                onChange={(e) => setEditStart(e.target.value)}
              />
              <ModalLabel>Closing Time</ModalLabel>
              <TimeInput
                type="time"
                value={editEnd}
                onChange={(e) => setEditEnd(e.target.value)}
              />
              {error && <ErrorText>{error}</ErrorText>}
              <ModalSaveButton type="button" onClick={handleSaveEdit}>
                Save
              </ModalSaveButton>
            </ModalContent>
          </ModalOverlay>
        )}
      </FormContainer>
      {kybURL && kybURL !== "" && (
        <FullScreenContainer>
          <StyledIframe src={kybURL} title="stripe-kyb" allowFullScreen />
        </FullScreenContainer>
      )}
    </>
  );
};

function formatTime(time: string) {
  const [h, m] = time.split(":");
  const hour = parseInt(h, 10);
  const min = m;
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12.toString().padStart(2, "0")}:${min} ${ampm}`;
}

export default BusinessHours;
